import omit from "lodash/omit";
import type { OnboardingChatFormState } from "../repositories/onboardingFormChat.repository";
import type { MediumOnboardingFormState } from "../types";
import type { QuickMediumSignupPayload } from "../types";
import type {
  QuickTerreiroSocialSignupPayload,
  TerreiroSignupPayload,
} from "../types/terreiroSignup.types";

export const buildTerreiroSignupFromChat = (
  formState: OnboardingChatFormState,
): TerreiroSignupPayload => ({
  firstName: formState.firstName || "",
  lastName: formState.lastName || "",
  email: formState.email || "",
  phone: formState.phone || "",
  terreiroName: formState.terreiroName || "",
  religionId: formState.religionId || "",
  password: formState.password || "",
  confirmPassword: formState.confirmPassword || formState.password || "",
  foundationDate: formState.foundationDate,
  initiationDate: formState.initiationDate,
  rankId: formState.rankId,
  roleId: formState.roleId,
  hasBankAccount: formState.hasBankAccount,
  bankOptionId: formState.bankOptionId,
  agency: formState.agency,
  account: formState.account,
  pixKeyType: formState.pixKeyType,
  pixKey: formState.pixKey,
  initialBalance: formState.initialBalance,
  monthlyFee: formState.monthlyFee,
  dueDay: formState.dueDay,
  receivingAccount: formState.receivingAccount,
  paymentMethod: formState.paymentMethod,
  isMedium: true,
  leader: true,
});

export const buildTerreiroSocialSignupFromChat = (
  formState: OnboardingChatFormState,
): QuickTerreiroSocialSignupPayload =>
  omit(buildTerreiroSignupFromChat(formState), [
    "password",
    "confirmPassword",
  ]) as QuickTerreiroSocialSignupPayload;

export const buildMediumSignupFromChat = (
  formState: OnboardingChatFormState,
): QuickMediumSignupPayload => ({
  firstName: formState.firstName || "",
  lastName: formState.lastName || "",
  email: formState.email || "",
  birthDate: formState.birthDate || "",
  phone: formState.phone || "",
  password: formState.password || "",
  confirmPassword: formState.confirmPassword || formState.password || "",
  guardianName: formState.guardianName,
  guardianPhone: formState.guardianPhone,
  guardianRelationship: formState.guardianRelationship,
  documentType: formState.documentType as QuickMediumSignupPayload["documentType"],
  document: formState.document,
  contact: formState.contact,
  rankId: formState.rankId,
  roleId: formState.roleId,
  initiationDate: formState.initiationDate,
  street: formState.street,
  number: formState.number,
  complement: formState.complement,
  neighborhood: formState.neighborhood,
  city: formState.city,
  state: formState.state,
  zipCode: formState.zipCode,
});

export const buildMediumOnboardingFormStateFromChat = (
  formState: OnboardingChatFormState,
): MediumOnboardingFormState => ({
  firstName: formState.firstName || "",
  lastName: formState.lastName || "",
  email: formState.email || "",
  phone: formState.phone || "",
  birthDate: formState.birthDate || "",
  initiationDate: formState.initiationDate || "",
  contact: formState.contact || "",
  documentType: formState.documentType || "",
  document: formState.document || "",
  rankId: formState.rankId || "",
  roleId: formState.roleId || "",
  street: formState.street || "",
  number: formState.number || "",
  complement: formState.complement || "",
  city: formState.city || "",
  state: formState.state || "",
  neighborhood: formState.neighborhood || "",
  zipCode: formState.zipCode || "",
  password: formState.password || "",
  confirmPassword: formState.confirmPassword || "",
  guardianName: formState.guardianName || "",
  guardianPhone: formState.guardianPhone || "",
  guardianRelationship: formState.guardianRelationship || "",
});
